export default {
 //rooturl: "http://localhost:3001/kugiapi/",
 rooturl: "https://kugi.ina-sdi.or.id:8080/kugiapi/",
  //rooturl: "http://35.198.225.7:8080/kugiapi-0.0.1-SNAPSHOT/",
  //rooturl: "http://www.mocky.io/v2/5d187f65300000ea238beaf9/",
  //apikey: "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJmZXJuaWF3YW5AcmVkYml0LmNvLmlkIiwiZXhwIjoxNTkyNDMxMDA1fQ.tRIyIaM_u8JNqde_SMFNfBQAyJxmUOfaHXVuqaeLHat6e3MbTCyYOF5sgOKLGd6gwcfdaiqG6RUEv99N20Y_lw"
  apikey: "Bearer "
  };
